import type * as ws from 'ws';
import type * as express from 'express';
import {Accounts} from '../account';
import {AccountGroup, TraderDBAccount, type TraderDbTraderAccount} from '../traderdb';

export * from './session';

// eslint-disable-next-line @typescript-eslint/naming-convention
export type QEPRequest = {
  session?: Session;
} & express.Request;
export type Session = {
  cookie: any;
  user?: User;
  wsUUID?: string;
  subscriptions?: Record<string, any>;
  save?: (...args: any[]) => any;
  destroy?: (...args: any[]) => any;
  id: string;
};

export type TokenResponse = {
  token_type: string;
  scope: string;
  expires_in: number;
  ext_expires_in: number;
  access_token: string;
  refresh_token: string;
  id_token: string;
  userToken: UserToken;
};
type UserToken = {
  aud: string;
  iss: string;
  iat: number;
  nbf: number;
  exp: number;
  aio: string;
  name: string;
  oid: string;
  preferred_username: string;
  rh: string;
  roles: string[];
  sub: string;
  tid: string;
  uti: string;
  ver: string;
};
export type PartialUser = {
  upn: string;
  id?: number;
  timezone: string;
  jurisdiction?: string;
} & Partial<TokenResponse>;

export type User = {
  // accounts: Accounts;
  trader: TraderDbTraderAccount;
  marketData: any;
  permissionGroups: any;
  // accountGroups?:AccountGroup[]
  // traderAccounts?:TraderDBAccount[]
} & PartialUser;
export type WebSocketSession = {
  uuid: string;
  session: any;
} & ws;
export type SubscriptionCallback = (topic: string, data: SubscriptionCallbackPayload) => void;
export type SubscriptionCallbackPayload = {
  sequenceNumber: number;
  payload: any;
};
export type SubscriptionResponsePayload = {
  sequenceNumber: number;
  payload: any;
};
export type WebSocketResponsePayload = {
  responseType: string;
  requestId: string;
  payload: any;
  topic: string;
};
export type SubscriptionMessage = {
  messageType: string;
  topic: string;
  data: any;
  requestId: string;
};

export type SubscriptionMessagePayload = {
  sequenceNumber?: number;
  metaData: any;
  payload: any;
};
export type SubscriptionMessagePayloadInternal = {
  type: string;
  data: any;
  subscriberUID: string;
  meta?: any;
};

export type SubscriptionClient = {
  ws: WebSocketSession;
  clientUUID: string;
  requestId?: string;
  session: any;/// SessionUser;
  subscriptions?: Record<string, any>;
  cb?: (...args: any[]) => any;
};
